import axios from 'axios'
import _ from 'lodash'
import store from '@/store'
import utils from '@/lib/utils'

function shouldAuthorize (config) {
  return !(
    config.url === '/authorize/login' ||
    (config.url === '/sys/terminal/' && config.method === 'get') ||
    (config.url === '/userEntity/' && config.method === 'get'))
}

export default function ({ baseUrl, timeout }) {
  const instance = axios.create({
    baseURL: baseUrl,
    timeout: timeout
  })
  instance.interceptors.request.use(function (config) {
    if (shouldAuthorize(config)) {
      const token = store.state.bis?.authorize?.token
      if (token) {
        _.set(config, 'headers.Authorization', token)
      } else {
        console.warn('尝试以匿名身份访问要求身份验证的服务接口', config)
      }
    }
    return config
  }, function (error) {
    const message = '请求服务端时发生错误'
    console.error(message, error)
    return Promise.resolve(utils.perfectApiResult({
      error: true,
      success: false,
      message
    }))
  })
  instance.interceptors.response.use(function (response) {
    const result = response.data
    if (result instanceof Blob) {
      // 文件数据
      return utils.perfectApiResult({
        success: true,
        message: null,
        data: result
      })
    }
    if (_.isNumber(result?.code)) {
      // 忽略BIS后台架构自带的success
      result.success = result.code >= 200 && result.code < 300
      if (result.success) {
        if (!result.data) {
          console.info('请求服务接口成功, 但数据为空', result, response)
        }
      } else {
        console.warn('请求服务接口失败', result, response)
        if (!result.message) {
          result.message = `请求服务接口失败(错误代码:${result.code})`
        }
        if (result.code === 401 || result.message === 'sso-jwt') {
          store.commit('bis/authorize/expire')
        }
      }
      return utils.perfectApiResult(result)
    } else {
      const message = '服务端响应结果异常'
      console.error(message, response)
      return utils.perfectApiResult({
        error: true,
        success: false,
        message
      })
    }
  }, function (error) {
    const message = '访问服务端时发生网络错误, 请检查网络连接'
    console.error(message, error)
    return Promise.resolve(utils.perfectApiResult({
      error: true,
      success: false,
      message
    }))
  })
  return instance
}
